module.exports = __webpack_public_path__ + "img/tintuc21.bce386d3.png";